window.addEventListener('DOMContentLoaded', () => {
  const omnibusWidget = document.querySelector('#sniffie-omnibus-price')
  const omnibusWidgetPrice = document.querySelector('.sniffie-omnibus-price__price')
  const priceOverride = document.querySelector("#custom-omnibus-price")

  if (priceOverride && omnibusWidgetPrice) {
    omnibusWidgetPrice.innerHTML = priceOverride.innerText
  }

  setTimeout(() => {
    omnibusWidget.style.opacity = 1
  }, 25)
}, {once: true})
